import React, { useState } from 'react';
import './Experience.css';
import Aos from "aos";
import "aos/dist/aos.css"
import { useEffect } from "react";

const experienceData = {
  "Experience": [
    {
      title: "AI Engineer & Assistant Manager",
      company: "PNB MetLife India Insurance",
      date: "June 2025 – Present",
      description: [
        "Designed and developed AI-driven solutions for multiple business use cases, improving operational efficiency.",
        "Collaborated with cross-functional teams to deliver AI initiatives and foster innovation.",
        "Ranked among the Top 5 teams in the Asia MetLife Festival global AI hackathon.",
        "Recognized as an AI Champion, driving AI adoption and awareness across the organization."
      ]
    },
    {
      title: "AI Software Engineer",
      company: "Workstein",
      date: "May 2025 – June 2025",
      description: [
        "Integrated AI solutions into Worksheet platform, enhancing process optimization and efficiency.",
        "Implemented real-time insights for faster, data-driven decision-making.",
        "Optimized AI use cases for effective deployment, ensuring maximum business impact."
      ]
    },
    {
      title: "ML Engineer & CTO",
      company: "Drifko Tech LLP",
      date: "Sept 2023 - Aug 2024",
      description: [
        "Spearheaded the development of 5+ SaaS products, boosting company growth by 30%.",
        "Streamlined dataset processing for LLMs, resulting in a 40% efficiency increase.",
        "Directed a team of 8 developers, driving a 900% revenue surge.",
        "Optimized ML models, improving efficiency by 25%."
      ]
    }
  ],
  "Education": [
    {
      title: "Bachelor of Technology, Computer Science",
      company: "ABES Institute of Technology, Ghaziabad",
      date: "2021 - 2025",
      description: [
        "GPA: 8.0/10.0",
        "Affiliated with Dr. A.P.J. Abdul Kalam Technical University, Uttar Pradesh."
      ]
    },
    {
      title: "AI and Machine Learning Training",
      company: "NVIDIA Partner - Global Infoventures Pvt. Ltd.",
      date: "Jan 2024 - June 2024",
      description: [
        "Hands-on experience with NVIDIA DGXA100 and Jetson Nano.",
        "Developed a PPE Violation Detection System and a Multi-Person Face Recognition model.",
        "Leveraged Docker for scalable, containerized AI model deployment."
      ]
    }
  ],
  "Achievements": [
    {
      title: "SIH 2024 Finalist",
      company: "Ministry of Jal Shakti",
      date: "December 2024",
      description: []
    },
    {
      title: "Exhibitor in Startup Mahakumbh 2024",
      company: "Represented team to dignitaries like Sanjeev Bickchandani, Piyush Goyal",
      date: "2024",
      description: []
    },
    {
      title: "Microsoft Azure Winner",
      company: "HackAIthon by SRIT Jabalpur",
      date: "",
      description: []
    }
  ]
};

function Experience() {
  const [activeTab, setActiveTab] = useState('Experience');

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <div id="experience" className="container-fluid">
      <h2 className="topic-head">My Journey</h2>
      <div className="experience-container">
        <div className="experience-tabs">
          {Object.keys(experienceData).map(tab => (
            <button
              key={tab}
              className={`tab-btn ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="experience-content" data-aos="fade-up" data-aos-once="true">
          {experienceData[activeTab].map((item, index) => (
            <div className="experience-item" key={index}>
              <h3 className="experience-title">
                {item.title}
                <span className="experience-company"> @ {item.company}</span>
              </h3>
              <p className="experience-date">{item.date}</p>
              <ul className="experience-description">
                {item.description.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Experience;
